import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import {
    Grid,
    IconButton,
    Link,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { SNACKBAR } from 'store/constant';

// project imports
import Avatar from 'ui-component/extended/Avatar';
import DeleteAlert from './DeleteAlert';
import ColoredDropdown from 'views/User/SimpleSpeedDials';
import { USER_STATUS } from 'store/constant';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

// third party
import moment from 'moment';
import { useSnackbar } from 'notistack';

const BoardList = ({ setReload, rows, handleClickOpen, page, limit }) => {

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const copyRef = useRef('');

    const formatSecondsToMinutes = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        const minutessLabel = minutes <= 1 ? 'min' : 'mins'
        const secondsLabel = seconds <= 1 ? 'sec' : 'secs'
        return `${minutes} ${minutessLabel} ${remainingSeconds.toString().padStart(2, '0')} ${secondsLabel}`;
    };

    const handleViewVenue = (venueUuid) => {
        navigate(`/venue/view/${venueUuid}`);
    };

    const handleViewBoard = (boardUuid) => {
        navigate(`/board/view/${boardUuid}`);
    };

    // const handleCopyLink = (boardUrl) => {
    //     const textArea = document.createElement('textarea');
    //     textArea.value = boardUrl;
    //     document.body.appendChild(textArea);
    //     textArea.focus();
    //     textArea.select();
    //     try {
    //         document.execCommand('copy');
    //         // alert('Copied link successfully');
    //         enqueueSnackbar('Copied link successfully', SNACKBAR.success);
    //     } catch (err) {
    //         enqueueSnackbar('Unable to copy to clipboard', SNACKBAR.error);

    //     }
    //     document.body.removeChild(textArea);
    // };

    const handleCopyLink = async (boardUrl) => {

        // if (!navigator.clipboard) {
        //     enqueueSnackbar('Clipboard API not supported or not available in this context.', SNACKBAR.error);
        //     return;
        // }
        // try {
        //     await navigator.clipboard.writeText(boardUrl);
        //     enqueueSnackbar('Copied link successfully', SNACKBAR.success);
        // } catch (err) {
        //     console.log(err);
        //     enqueueSnackbar('Unable to copy to clipboard', SNACKBAR.error);
        // }
        // copyRef.current = boardUrl;
        // // copyRef.current.select();
        // document.execCommand('copy');
        // enqueueSnackbar('Copied link successfully', SNACKBAR.success);
        const textarea = document.createElement('textarea');
        textarea.value = boardUrl;
        // Make the textarea invisible and place it offscreen
        textarea.style.position = 'absolute';
        textarea.style.opacity = '0';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            enqueueSnackbar('Copied link successfully', SNACKBAR.success);
        } catch (err) {
            enqueueSnackbar('Unable to copy to clipboard', SNACKBAR.error);
        }

        // Remove the textarea element after copying
        document.body.removeChild(textarea);
    };

    const changeStatusHandler = () => {
        setReload(r => !r)
    };

    const changeStatus = (rowUuid) => {
        changeStatusApi.execute(rowUuid);
    };

    const changeStatusApi = useApi(VenueService.changeBoardStatusByUuid, changeStatusHandler, true)

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell>Board Id</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Board Name</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} >Venue Name</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Court Name</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Price Per Hour</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Discount</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Bookings</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Total Usage Time</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Size</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">Board URL</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>Last Active Time</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="center">Active</TableCell>
                        <TableCell align="center" sx={{ pr: 3 }}>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Typography align="left" variant="subtitle1" component="div">
                                        <Link
                                            underline='always'
                                            onClick={() => handleViewBoard(row.uuid)}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {row.board_id}
                                        </Link>
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.name}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', pr: 10 }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Avatar alt="Venue" src={row.banner_image} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                <Link underline='always' onClick={() => handleViewVenue(row.uuid_venue)} sx={{
                                                    cursor: 'pointer'
                                                }}>{row.venue_name}</Link>
                                            </Typography>
                                            <Typography align="left" variant="subtitle2" noWrap>
                                                {row.owner_name}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.turf_name}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', padding: '3px 3px' }}>
                                    <Typography sx={{ paddingTop: 0.5, paddingBottom: 0.5 }}>Week Day : <b>&#8377;{row.weekday_price}</b></Typography>
                                    <Typography sx={{ paddingBottom: 0.5 }}>Week End : <b>&#8377;{row.weekend_price}</b></Typography>
                                    <Typography sx={{ paddingBottom: 0.5 }}>Holiday : <b>&#8377;{row.holiday_price}</b></Typography>

                                </TableCell>
                                <TableCell>
                                    {row.discount_percentage >= 0 ? row.discount_percentage + '%' : ''}
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.booking_count}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatSecondsToMinutes(row.played_seconds)}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    {row.board_width ? row.board_width + ' X ' + row.board_height : ''}
                                </TableCell>
                                <TableCell align="center">
                                    <Tooltip placement="top" title="Copy Link">
                                        <IconButton
                                            color="inherit"
                                            aria-label="copy"
                                            size="large"
                                            onClick={() => handleCopyLink(row.board_url)}
                                        >
                                            <ContentCopyIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell>
                                    {row.last_active_time ? (
                                        <Grid container spacing={2}>
                                            <Grid item xs zeroMinWidth>
                                                <Typography align="left" variant="subtitle1" component="div">
                                                    {moment(row.last_active_time.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')}
                                                </Typography>
                                                <Typography align="left" variant="subtitle2" noWrap>
                                                    {moment(row.last_active_time.replace('T', ' ').replace('.000Z', '')).format('HH:mm:ss')}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ) : (<>-</>)}
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    <ColoredDropdown
                                        itemArray={USER_STATUS}
                                        selectedValue={row.is_active}
                                        rowUuid={row.uuid}
                                        handleChange={changeStatus}
                                    />
                                </TableCell>
                                <TableCell align="center" sx={{ pr: 3 }}>
                                    <Stack direction="row" justifyContent="center" alignItems="center">
                                        <Tooltip placement="top" title="Edit">
                                            <IconButton
                                                color="primary"
                                                aria-label="edit"
                                                size="large"
                                                onClick={() => handleClickOpen(row.uuid)}
                                            >
                                                <EditIcon sx={{ fontSize: '1.1rem' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <DeleteAlert setReload={setReload} boardUuid={row.uuid} />
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table >
        </TableContainer >
    );
};

export default BoardList;
